// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--V5wV3","footerInnerContainer":"footer-module--footerInnerContainer--3hltg","footerRow":"footer-module--footerRow--2HP4y"};